<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Wydania z magazynu'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <!--  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">-->
  <!--      -->
  <!--  </form>-->

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="15px">
      <button
        [disabled]="!(userPermissions | async)?.marketing.write || !hasSelectedItems"
        (click)="confirmWz()"
        mat-stroked-button
        color="primary"> <span> Zatwierdź WZ </span></button>
      <button
        [disabled]="!(userPermissions | async)?.marketing.write"
        (click)="generatePdf()"
        mat-stroked-button
        color="primary">
        <span> Pobierz WZ </span>
      </button>
      <button
        [disabled]="!(userPermissions | async)?.marketing.write || !hasProtocolItems"
        (click)="generateProtocols()"
        mat-stroked-button
        color="primary">
        <span> Pobierz protokoły </span>
      </button>

      <button
        *ngIf="!isWzReleased"
        [disabled]="!(userPermissions | async)?.marketing.write"
        (click)="addProducts()"
        mat-stroked-button
        color="primary">
        <span> Dodaj z magazynu </span>
      </button>

      <button
        *ngIf="!isWzReleased"
        [disabled]="!(userPermissions | async)?.marketing.write"
        (click)="addRows()"
        mat-stroked-button
        color="primary">
        <span> Dodaj nagrodę </span>
      </button>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).marketing.read" (click)="downloadReport()" [disabled]="!(userPermissions | async).marketing.read"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    </div>
  </div>


  <table mat-table [dataSource]="wzDataSource">

    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef> Wybierz </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox *ngIf="element?.status?.key !== WZ_STATUS_RELEASED" [formControl]="element.checkbox"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="awardId">
      <th mat-header-cell *matHeaderCellDef> Nagroda (przypisana z bazy po nr ID) </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link"
           [routerLink]="['/stan-magazynowy/szczegoly', (element?.warehouseProduct || element?.competitionImportRow?.warehouseProduct)?.uuid]">
          {{ (element?.warehouseProduct || element?.competitionImportRow?.warehouseProduct)?.productName ?? "" }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="competitionSettledOn">
      <th mat-header-cell *matHeaderCellDef> Konkurs rozliczany na </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element?.competitionImportRow?.competitionImport?.partner">
          Partner
        </ng-container>

        <ng-container *ngIf="element?.competitionImportRow?.competitionImport?.ofwca">
          OFWCA
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="protocol">
      <th mat-header-cell *matHeaderCellDef> Wymagany protokół </th>
      <td mat-cell *matCellDef="let element">
        {{element?.competitionImportRow?.warehouseProduct?.protocol ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Liczba </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element">
          {{ element?.amount || element?.competitionImportRow?.amount || 0 }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="laureate">
      <th mat-header-cell *matHeaderCellDef> Laureat </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.competitionImportRow?.partner && element.competitionImportRow?.competitionImport?.partner">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.competitionImportRow?.uuid]">{{element?.competitionImportRow?.partner?.shortName ? element?.competitionImportRow?.partner?.shortName : ""}}</a>
        </ng-container>

        <ng-container *ngIf="element.competitionImportRow?.ofwca && element.competitionImportRow?.competitionImport?.ofwca">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.competitionImportRow?.uuid]">{{element?.competitionImportRow?.ofwca?.fullName ? element?.competitionImportRow?.ofwca?.fullName : ""}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.competitionImportRow?.partner && element.competitionImportRow?.competitionImport?.partner">
          {{element.competitionImportRow?.partner?.assetsRegional?.firstName}} {{element.competitionImportRow?.partner?.assetsRegional?.lastName}}
        </ng-container>

        <ng-container *ngIf="element.competitionImportRow?.ofwca && element.competitionImportRow?.competitionImport?.partner">
          {{element.competitionImportRow?.ofwca?.assetsRegional?.firstName}} {{element.competitionImportRow?.ofwca?.assetsRegional?.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="competition">
      <th mat-header-cell *matHeaderCellDef> Konkurs </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/szczegoly', element?.competitionImportRow?.competitionImport?.uuid]">{{element?.competitionImportRow?.competitionImport?.competitionName ? element?.competitionImportRow?.competitionImport?.competitionName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element?.status?.color + '-button'">{{element?.status?.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button *ngIf="element?.status?.key !== WZ_STATUS_RELEASED" [disabled]="!(userPermissions | async).marketing.admin_root" (click)="delete(element)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>

      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
